import React from 'react';
import { ExternalLink } from 'lucide-react';
export function Footer() {
  const partnerLinks = [{
    name: 'ttvip-64.com',
    url: 'https://ttvip-64.com/'
  }, {
    name: 'shiok27.com',
    url: 'https://shiok27.com/'
  }, {
    name: 'xfy01.net',
    url: 'https://xfy01.net/'
  }, {
    name: 'sgharem6.net',
    url: 'https://sgharem6.net/'
  }, {
    name: 'qc52.me',
    url: 'https://qc52.me/'
  }, {
    name: 'geylang777.info',
    url: 'https://geylang777.info/'
  }, {
    name: 'geylang666.me',
    url: 'https://geylang666.me/'
  }, {
    name: 'isyou.net',
    url: 'https://isyou.net/'
  }, {
    name: 'ttvip-62.site',
    url: 'https://ttvip-62.site/'
  }, {
    name: 'shiok26.site',
    url: 'https://shiok26.site/'
  }, {
    name: 'sgharem.site',
    url: 'https://sgharem.site/'
  }, {
    name: 'xfy8.com',
    url: 'https://xfy8.com/'
  }];
  const quickLinks = [{
    name: '首页 (Home)',
    href: '#home'
  }, {
    name: '服务 (Services)',
    href: '#services'
  }, {
    name: '关于我们 (About)',
    href: '#about'
  }, {
    name: '评价 (Reviews)',
    href: '#reviews'
  }];
  return <footer className="bg-brand-green text-white pt-16 pb-8 relative z-20" data-id="element-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-11">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 lg:gap-8 mb-12" data-id="element-12">
          {/* Brand Info */}
          <div className="col-span-1" data-id="element-13">
            <div className="flex items-baseline gap-2 mb-4" data-id="element-14">
              <span className="text-2xl font-serif font-bold tracking-wide text-white" data-id="element-15">
                新加坡爽吧
              </span>
              <span className="text-xl font-serif font-semibold text-brand-gold" data-id="element-16">
                Shiok8
              </span>
            </div>
            <p className="text-white/70 text-sm leading-relaxed max-w-xs" data-id="element-17">
              新加坡历史最悠久的专业 Escort
              推荐平台。自2003年起，为您提供最优质、最可靠的陪伴服务体验。
            </p>
          </div>

          {/* Quick Links */}
          <div className="col-span-1" data-id="element-18">
            <h3 className="text-lg font-bold mb-6 text-brand-gold font-serif" data-id="element-19">
              快速导航 / Quick Links
            </h3>
            <ul className="space-y-3" data-id="element-20">
              {quickLinks.map((link, index) => <li key={index} data-id="element-21">
                  <a href={link.href} className="text-white/70 hover:text-white transition-colors text-sm flex items-center gap-2" data-id="element-22">
                    <span className="w-1.5 h-1.5 rounded-full bg-brand-gold/50" data-id="element-23"></span>
                    {link.name}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Partner Links */}
          <div className="col-span-1" data-id="element-24">
            <h3 className="text-lg font-bold mb-6 text-brand-gold font-serif" data-id="element-25">
              友站链接 / Partner Sites
            </h3>
            <ul className="space-y-3" data-id="element-26">
              {partnerLinks.map((link, index) => <li key={index} data-id="element-27">
                  <a href={link.url} target="_blank" rel="noopener noreferrer" className="text-white/70 hover:text-brand-gold transition-colors text-sm flex items-center gap-2 group" data-id="element-28">
                    <ExternalLink className="w-3.5 h-3.5 opacity-50 group-hover:opacity-100 transition-opacity" data-id="element-29" />
                    {link.name}
                  </a>
                </li>)}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-30">
          <p className="text-white/50 text-xs text-center md:text-left" data-id="element-31">
            &copy; {new Date().getFullYear()} 新加坡爽吧 Shiok8. All rights
            reserved.
          </p>
          <p className="text-white/30 text-xs text-center md:text-right" data-id="element-32">
            Premium Singapore Escort Recommendation Platform
          </p>
        </div>
      </div>
    </footer>;
}